/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lens_Group_AllInputs */

const en_lens_group_all = /** @type {(inputs: Lens_Group_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every brand`)
};

/**
* | output |
* | --- |
* | "Every brand" |
*
* @param {Lens_Group_AllInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const lens_group_all = /** @type {((inputs?: Lens_Group_AllInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lens_Group_AllInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_lens_group_all(inputs)
});